<template>
  <div class="information-container">
    <div v-for="(info, index) in information" :key="index">

      <div v-if="isShow(info.showHome)" class="line-container">

        <div class="date-new-icon">
          <div class="date">{{info.date}}</div>
          <div class="new-icon-container">
            <span v-if="info.new" class="newIcon">NEW</span>
          </div>
        </div>
        <div class="contents">
          <router-link v-if="info.linkTo" :to="{name: info.linkTo}">
            {{info.data}}
          </router-link>
          <a v-else-if="info.linkTo" :href="info.linkRef" target="_blank">
            {{info.data}}
          </a>
          <span v-else>
            {{info.data}}
          </span>
        </div>

      </div>
    </div>

  </div>
</template>

<script>

export default {
  props: ['isHome'],
  methods: {
    isShow: function (showHome) {
      if (this.isHome) {
        if (showHome === true) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
  data () {
    return {
      information: [
        {
          date: '2024年7月8日',
          data: '株式会社エーフォーワークスは設立10周年を迎えました',
          linkTo: null,
          linkRef: null,
          new: true,
          showHome: true
        },
        {
          date: '2024年5月24日',
          data: 'スマホ向けブラウザゲーム「サマサガ」クラウドファンディング終了(目標259%達成)',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2024年4月10日',
          data: 'スマホ向けブラウザゲーム「サマサガ」CAMPFIREにてクラウドファンディングを開始',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2024年3月28日',
          data: 'スマホ向けブラウザゲーム「サマサガ」(アルファ版)をリリースしました',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2024年2月1日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2023年9月1日',
          data: 'クライアントワーク事業部を新設しました',
          linkTo: 'Works',
          linkRef: null,
          new: null,
          showHome: true
        },
        {
          date: '2023年4月7日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2022年7月1日',
          data: '事業企画室を新設しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2022年6月10日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: true
        },
        // {
        //   date: '2022年7月8日',
        //   data: 'サービス「リモメシ」を正式サービス版をリリースしました',
        //   linkTo: 'WorksRemoteWorkLunch',
        //   linkRef: null,
        //   new: false,
        //   showHome: true
        // },
        {
          date: '2021年12月17日',
          data: '本社移転のお知らせ',
          linkTo: 'Corporate',
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2021年7月28日',
          data: 'サービス「リモメシ」をベータ版をリリースしました',
          linkTo: 'WorksRemoteWorkLunch',
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2020年9月29日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'WorksCREPOS',
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2020年6月12日',
          data: 'サービス「こどもペイ」を正式リリースしました',
          linkTo: 'WorksKodomopay',
          linkRef: null,
          new: false,
          showHome: true
        },
        {
          date: '2020年5月27日',
          data: 'サービス「こどもペイ」をベータ版をリリースしました',
          linkTo: 'WorksKodomopay',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2019年10月28日',
          data: 'コーポレートサイトをリニューアルしました',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2018年6月8日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2018年1月13日',
          data: 'LINEスタンプ「いま、ここです〜 その2」の販売を開始しました',
          linkTo: 'WorksImHere2',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2017年12月26日',
          data: '「AFTER FIRE Re Online」iOS版・Android版の配信を開始しました',
          linkTo: null,
          linkRef: 'https://www.afterfire.info/',
          new: false,
          showHome: false
        },
        {
          date: '2017年7月13日',
          data: 'LINEスタンプ「いま、ここです〜」の販売を開始しました',
          linkTo: 'WorksImHere',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2016年11月17日',
          data: '会社概要を更新しました',
          linkTo: 'Corporate',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2016年10月21日',
          data: 'サービス・事例紹介に「ゼロヨンシフト3rd」を追加しました',
          linkTo: 'WorksZs3',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2016年5月26日',
          data: 'サービス・事例紹介に「森のえほん館」を追加しました',
          linkTo: 'WorksEhonkan',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年12月18日',
          data: 'サービス・事例紹介に「AFTER FIRE Re」Google Play版を追加しました',
          linkTo: null,
          linkRef: 'https://www.afterfire.info/',
          new: false,
          showHome: false
        },
        {
          date: '2015年11月26日',
          data: 'サービス・事例紹介に「AFTER FIRE Re」を追加しました',
          linkTo: null,
          linkRef: 'https://www.afterfire.info/',
          new: false,
          showHome: false
        },
        {
          date: '2015年6月8日',
          data: 'サービス・事例紹介に「Pictbox」を追加しました',
          linkTo: 'WorksPictbox',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年5月1日',
          data: '株式会社パーソンリンクと業務提携契約を締結致しました',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年5月1日',
          data: 'LINEスタンプ「打・蹴・投・極」(だしゅうとうごく)の販売を開始しました',
          linkTo: 'WorksRide2victory',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年3月28日',
          data: 'LINEスタンプ「チェルシー＆ちびチェルシー」の販売を開始しました',
          linkTo: 'WorksChelsea',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年3月28日',
          data: 'LINEスタンプ「なにわの石井さん」の販売を開始しました',
          linkTo: 'WorksIshiiSan',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年3月28日',
          data: 'LINEスタンプ「はにわん」の販売を開始しました',
          linkTo: 'WorksHaniwan',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年3月17日',
          data: 'LINEスタンプ「とまとのあかりちゃん」の販売を開始しました',
          linkTo: 'WorksAkari',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2015年2月3日',
          data: '採用情報を更新しました',
          linkTo: 'Recruit',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2014年12月9日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2014年12月3日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2014年10月7日',
          data: 'サービス・事例紹介を追加しました',
          linkTo: 'Works',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2014年10月2日',
          data: '採用情報を追加しました',
          linkTo: 'Recruit',
          linkRef: null,
          new: false,
          showHome: false
        },
        {
          date: '2014年08月12日',
          data: 'オフィシャルブログを開始しました',
          linkTo: null,
          linkRef: 'https://blog.a4works.co.jp/',
          new: false,
          showHome: false
        },
        {
          date: '2014年07月15日',
          data: 'コーポレートサイトをオープンしました',
          linkTo: null,
          linkRef: null,
          new: false,
          showHome: false
        }
      ]
    }
  }
}

</script>

<style lang="scss" scoped>

  a {
    padding: 4px 0 2px 4px;
    border-bottom: 1px solid #ddd;
  }

  a.contents:link,
  a.contents:visited,
  a.contents:active {
    color: #333333;
    text-decoration: underline;
    border-bottom: none;
  }

  a.contents:hover {
    color: #000000;
    border-bottom: none;
  }

  .information-container {
    font-size: 14px;
    padding: 0 10px;
  }

  .newIcon {
    display: inline-block;
    font-size: 10px;
    line-height: 10px;
    background: #f55;
    color: #fff;
    border-radius: 3px;
    text-align: center;
    padding: 2px 4px 2px 4px;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .line-container {
      display: flex;
      line-height: 30px;
    }

    .date-new-icon {
      display: flex;
    }

    .new-icon-container {
      display: inline-block;
      width: 45px;
      text-align: center;
    }

    .date {
      width: 120px;
    }

    .new-icon-container-R{
      display: none;
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .line-container {
      line-height: 30px;
    }

    .date-new-icon {
      display: flex;
    }

    .date {
      padding-right: 10px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/common/Information.vue